<div class="is-relative margin-desktop">
  <svg #rail class="rail" aria-hidden="true" width="100%" height="64" viewBox="0 0 100 64" preserveAspectRatio="none" >
    <path #railPath
          d="M 0 32 C 11.111 16, 22.222 16, 33.333 32 C 44.444 48, 55.556 48, 66.667 32 C 77.778 16, 88.889 16, 100 32"
          fill="none"
          stroke="#1ea7fd"
          stroke-width="2"
          stroke-linecap="butt"
          stroke-dasharray="12 8"
          vector-effect="non-scaling-stroke" />
  </svg>
  <mat-stepper
    labelPosition="bottom"
    [linear]="true"
    [class.stepper-locked]="isLockedForClient()"
    #stepper
    (selectedIndexChange)="onChangeIndex($event)">
    <mat-step
      label="{{ 'my.project' | translate }}"
      state="edit"
      [editable]="stepperIndex() > 0 && !isLockedForClient()"
      [stepControl]="validProject">
    </mat-step>
    <mat-step
      label="{{ 'my.infos' | translate }}"
      state="done"
      [editable]="stepperIndex() > 1 && !isLockedForClient()"
      [stepControl]="validInfo">
    </mat-step>
    <mat-step
      label="{{ 'my.tarifs' | translate }}"
      state="done"
      [editable]="stepperIndex() > 2 && !isLockedForClient()"
      [stepControl]="validTarif">
    </mat-step>
    <mat-step
      label="{{ 'my.sub' | translate }}"
      state="done"
      [editable]="false"
      [stepControl]="validSouscription">
    </mat-step>
    <!-- Icon overrides. -->
    <ng-template matStepperIcon="edit">
      <mat-icon class="is-size-6">check</mat-icon>
    </ng-template>
    <!--
      Un step franchi mais non éditable passe en état "done" : même visuel que l'état "edit"
      pour que le fil d'ariane verrouillé reste identique à celui du parcours classique.
    -->
    <ng-template matStepperIcon="done">
      <mat-icon class="is-size-6">check</mat-icon>
    </ng-template>
  </mat-stepper>
</div>
